import './index.css';
import { useState, useLayoutEffect, useEffect } from 'react';
import { useDomStoredUniqueId, getValueFromDom, storeValueInDom } from '@hh.ru/magritte-common-dom-storage';

const STORAGE_NAME = '_MAGRITTE_MODAL_COUNTER_';
const getState = () => {
    const state = getValueFromDom(STORAGE_NAME);
    if (state === undefined) {
        return {
            prevVisiblility: {},
            positions: {},
            subscribers: {},
            count: 0,
        };
    }
    return state;
};
const storeState = (state) => {
    storeValueInDom(STORAGE_NAME, state);
};
const counterFactory = () => {
    return {
        updateVisiblility: (id, visible) => {
            // eslint-disable-next-line prefer-const
            const state = getState();
            const prevVisible = !!state.prevVisiblility[id];
            if (visible === prevVisible) {
                return;
            }
            state.prevVisiblility[id] = visible;
            if (visible) {
                state.count += 1;
                state.positions[id] = state.count;
            }
            else {
                state.count -= 1;
                const currentPosition = state.positions[id];
                state.positions[id] = 0;
                Object.entries(state.positions).forEach(([key, value]) => {
                    state.positions[key] = value > currentPosition ? value - 1 : value;
                });
            }
            storeState(state);
        },
        subscribe: (id, callback) => {
            const state = getState();
            state.subscribers[id] = callback;
            storeState(state);
        },
        unsubscribe: (id) => {
            const state = getState();
            delete state.subscribers[id];
            storeState(state);
        },
        notifyAll: () => {
            const { subscribers, count, positions } = getState();
            Object.entries(subscribers).forEach(([id, callback]) => callback({ position: positions[id], count }));
        },
    };
};
const counter = counterFactory();
const useModalOrder = (visible, modalRef) => {
    const [position, setPosition] = useState({ position: 0, count: 0 });
    const id = useDomStoredUniqueId();
    useLayoutEffect(() => {
        counter.updateVisiblility(id, visible);
        counter.notifyAll();
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, [visible]);
    useEffect(() => {
        counter.subscribe(id, setPosition);
        counter.updateVisiblility(id, visible);
        return () => {
            counter.unsubscribe(id);
            counter.updateVisiblility(id, false);
            counter.notifyAll();
        };
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, [id]);
    useLayoutEffect(() => {
        // Если это самый "верхний" модал передаем туда фокус
        if (position.position === position.count &&
            position.count > 0 &&
            !modalRef.current?.contains(document.activeElement)) {
            modalRef.current?.focus();
        }
    }, [position, modalRef]);
    return [position.position, position.count];
};

export { useModalOrder };
//# sourceMappingURL=useModalOrder.js.map
